import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';

import { CCEuro24GameId, T } from '../../../constants';
import { useTranslation } from '../../../hooks';
import { useStore } from '../../../hooks';

import PascalLogo from '../../../assets/media/logos/pascal-gaming-new-logo.png';

import './style.scss';

interface ErrorPopupProps {
  title?: string;
  message: string;
  hasExit: boolean;
  hasClose: boolean;
  hasReload: boolean;
  displayErrorCode?: number | string;
}

export const ErrorPopup: React.FC<ErrorPopupProps> = observer(({
  title,
  message,
  hasExit,
  hasClose,
  hasReload,
  displayErrorCode
}) => {

  const t = useTranslation();
  const { gameStore, modalStore } = useStore();

  const { launchData: { data }, gameId, relaunchPending } = gameStore;
  const exitUrl = data?.exitUrl;

  const onHomeClick = useCallback(() => {
    if (!exitUrl) return;
    window.location.href = exitUrl;
  }, [exitUrl]);

  const onRefreshClick = useCallback(() => {
    // reloadGame keeps relaunchPending truthful whether it relaunches now or defers to the cooldown.
    gameStore.reloadGame();
  }, []);

  const onCloseClick = useCallback(() => {
    modalStore.closeGameInterruptionModal();
  }, []);

  return (
    <div className="error-popup-overlay">
      <div className="error-popup-card">
        <div className="error-popup-logo">
          <img src={PascalLogo} alt="pascal-gaming" />
        </div>
        {
          title ? (
            <h2 className="error-popup-title">{t(title)}</h2>
          ) : null
        }
        <p className="error-popup-message">{t(message)}</p>
        {
          displayErrorCode ? (
            <span className="error-popup-code">{displayErrorCode}</span>
          ) : null
        }
        <div className="error-popup-actions">
          {
            (exitUrl && hasExit) ? (
              <button
                type="button"
                className="error-popup-home-btn"
                onClick={onHomeClick}
                aria-label="home"
              >
                <i className="icon-lobby" />
              </button>
            ) : null
          }
          {
            hasClose && (
              <button
                type="button"
                onClick={onCloseClick}
                className="error-popup-refresh-btn"
              >
                {t(T.CLOSE)}
              </button>
            )
          }
          {
            (hasReload && gameId !== CCEuro24GameId) && (
              <button
                type="button"
                className="error-popup-refresh-btn"
                onClick={onRefreshClick}
                disabled={relaunchPending}
              >
                {t(relaunchPending ? T.RELOADING : T.REFRESH)}
              </button>
            )
          }
        </div>
      </div>
    </div>
  );
});
